// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MuteIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MuteIcon" ref={forwardedRef} {...props}>
      <path d="M6.5 4.5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1zM8 12h4V5H8z" />
      <path d="m14.754 14.5-9.69-.002V11H3.75l.002 3.998C3.752 15.552 4.144 16 4.627 16h4.62v2h1.5v-2h4.503c.483 0 1-.449 1-1.002V11h-1.496z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MuteIcon = /* @__PURE__ */ Object.assign(MuteIconComponent, {
  displayName: 'MuteIcon',
});
